import React, { Component } from "react";
import WithConsumer from '../../context/WithConsumer';

export default class PageLargeText extends Component {
	state = {
		isOpen: false,
	};
	
	handleToggle = () => {
    	this.setState({ isOpen: !this.state.isOpen });
  	};
  	
	render () {
		
		let block 		= this.props.block;
		
		let butText = 'Read More +';
		if (this.state.isOpen === true) {
			butText = 'Read Less -';
		}
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect'}>
			    
			    	<div className="l-content">
			    		
			    		<div className="l-grid">
			    		
			    			<div className="l-grid__col">
			    			
			    				<h2 className="c-heading" dangerouslySetInnerHTML={{__html:block.heading}}></h2>
			    			
								<div className="scope-text scope-text--large" dangerouslySetInnerHTML={{__html:block.text}}></div>
								
								{block.read_more &&
									<div className={'c-large-text__accordion ' + (this.state.isOpen ? 'state-open' : "")}>
												
										<div className="c-large-text__accordion__body">
										
											<div className="c-large-text__accordion__body__inner">
																			
												<div className="scope-text--large" dangerouslySetInnerHTML={ {__html: block.read_more}}></div>
																					
											</div>
											
										</div>
										
										<h4 className="c-large-text__accordion__header" onClick={this.handleToggle} dangerouslySetInnerHTML={ {__html: butText}}></h4>
								
									</div>
								}
								
							</div>
			    			
			    		</div>
			    		
			    	</div>
			    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
